var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    { attrs: { "tab-position": "top" } },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: "History" } },
        [_c("accessory-history", { attrs: { registries: _vm.model.history } })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tab-pane",
        { attrs: { label: "Requests" } },
        [
          _c("accessory-own-requests", {
            attrs: { registries: _vm.model.requests },
          }),
        ],
        1
      ),
      _vm._v(" "),
      false
        ? _c(
            "el-tab-pane",
            { attrs: { label: "Related Requests" } },
            [
              _c("accessory-related-requests", {
                attrs: { registries: _vm.model.related },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      false
        ? _c(
            "el-tab-pane",
            { attrs: { label: "RMA Reviews" } },
            [
              _c("accessory-rma-reviews", {
                attrs: { registries: _vm.model.rmas },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }